import { useEffect, useRef } from 'react'
import { NativeEventEmitter, NativeModules } from 'react-native'

import { time } from '../util/date'

export const ONGOING_VIDEO_CALL_EVENT = 'ongoingVideoCall'

const heartbeatInterval = time.ms.Minute
const eventEmitter = new NativeEventEmitter(NativeModules.RNEventEmitter)

const useOngoingVideoCallEvent = (isOngoingVideoCall: boolean) => {
  const ongoingVideoCallIntervalRef = useRef<NodeJS.Timeout | null>(null)

  useEffect(() => {
    if (isOngoingVideoCall) {
      ongoingVideoCallIntervalRef.current = setInterval(() => {
        eventEmitter.emit(ONGOING_VIDEO_CALL_EVENT)
      }, heartbeatInterval)
    } else {
      if (ongoingVideoCallIntervalRef.current) {
        clearInterval(ongoingVideoCallIntervalRef.current)
        ongoingVideoCallIntervalRef.current = null
      }
    }

    // Cleanup function
    return () => {
      if (ongoingVideoCallIntervalRef.current) {
        clearInterval(ongoingVideoCallIntervalRef.current)
        ongoingVideoCallIntervalRef.current = null
      }
    }
  }, [isOngoingVideoCall])
}

export default useOngoingVideoCallEvent
